var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrush(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_2716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.84 16.316H12.75V12.526C12.75 11.926 12.26 11.436 11.66 11.436L4.17 11.456C2.98 11.456 2 10.476 2 9.27597V6.62597C2 5.42597 2.99 4.43597 4.2 4.43597H7.57V5.51597H4.19C3.59 5.51597 3.1 6.01597 3.1 6.61597V9.26597C3.1 9.86597 3.58 10.356 4.18 10.356L11.67 10.336C12.87 10.336 13.85 11.306 13.85 12.516V16.316H13.84Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.49 14.4659H11.81C11.64 17.0159 11.47 19.5659 11.3 22.1059C11.23 23.0459 12.04 23.6859 13.13 23.6859C14.22 23.6859 15.04 23.0359 14.97 22.1059C14.81 19.5659 14.65 17.0159 14.49 14.4759V14.4659ZM13.13 22.9059C12.74 22.9059 12.43 22.5959 12.43 22.2059C12.43 21.8159 12.75 21.5059 13.13 21.5059C13.52 21.5059 13.83 21.8159 13.83 22.2059C13.83 22.5959 13.51 22.9059 13.13 22.9059Z",
    fill: "#EE402F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.29 14.456C15.29 14.826 14.99 15.126 14.62 15.126H11.68C11.31 15.126 11.01 14.836 11.01 14.466C11.01 14.096 11.31 13.796 11.68 13.796H14.62C14.99 13.796 15.29 14.086 15.29 14.456Z",
    fill: "#B32E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.65 6.37595C22.65 7.14595 22.02 7.77595 21.25 7.77595L6.65001 7.80595C5.88001 7.80595 5.26001 7.18595 5.26001 6.41595V3.02595C5.26001 2.25595 5.90001 1.62595 6.67001 1.62595L21.26 1.59595C22.03 1.59595 22.65 2.21595 22.65 2.98595V6.37595Z",
    fill: "#EE402F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.13 23.1459C12.62 23.1459 12.2 22.7259 12.2 22.2159C12.2 21.6959 12.62 21.2759 13.14 21.2759C13.66 21.2759 14.07 21.6959 14.07 22.2059C14.07 22.7259 13.65 23.1459 13.13 23.1459ZM13.14 21.6859C12.85 21.6859 12.62 21.9259 12.62 22.2059C12.62 22.4959 12.85 22.7259 13.14 22.7259C13.43 22.7259 13.66 22.4959 13.66 22.2059C13.66 21.9159 13.43 21.6859 13.14 21.6859Z",
    fill: "#B32E20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_2716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.65,
    height: 22.09,
    fill: "white",
    transform: "translate(2 1.59595)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrush);
export default __webpack_public_path__ + "static/media/brush.c256ba92eca170820d8596d664510486.svg";
export { ForwardRef as ReactComponent };